var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88894 11V2.5C8.88894 2.22386 9.1128 2 9.38894 2C9.66508 2 9.88894 2.22386 9.88894 2.5V11C9.88894 11.4133 9.76905 12.0222 9.39471 12.5422C9.00201 13.0876 8.3519 13.5 7.38894 13.5H5.8899C5.53391 13.5 5.00066 13.5887 4.57616 13.8333C4.30352 13.9903 4.08314 14.2037 3.9706 14.5093C3.87518 14.7684 3.6653 15 3.38916 15C3.11302 15 2.88272 14.7737 2.93643 14.5028C3.08216 13.7679 3.54683 13.2721 4.077 12.9667C4.66778 12.6264 5.35072 12.5099 5.82666 12.5006L7.38894 12.5C8.02598 12.5 8.37587 12.2458 8.58317 11.9578C8.80883 11.6444 8.88894 11.2533 8.88894 11Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.88916,
    y: 0.5,
    width: 1.5,
    height: 13,
    rx: 0.75,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8892,
    y: 0.5,
    width: 1.5,
    height: 13,
    rx: 0.75,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88916,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.38916,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3892,
    y: 2,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/materialIcon.0ea106860578c552a2dc14f886a5978b.svg";
export { ForwardRef as ReactComponent };